import { Controller } from "@hotwired/stimulus"

// Controller genérico para abrir modais com conteúdo remoto.
//
// Uso no link:
//   data-controller="remote-modal"
//   data-action="click->remote-modal#open"
//   data-remote-modal-url-value="/jogos/38/checkins"
//
// Ou via data attribute no próprio link:
//   data-action="click->remote-modal#open"
//   href="/jogos/38/checkins"
//
export default class extends Controller {

  async open(event) {
    event.preventDefault()

    const url = this.element.dataset.remoteModalUrlValue || this.element.href
    if (!url) return

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) return

      const html = await response.text()

      // Insere o conteúdo no container
      let container = document.getElementById("remote-modal-container")
      if (!container) {
        container = document.createElement("div")
        container.id = "remote-modal-container"
        document.body.appendChild(container)
      }
      container.innerHTML = html

      // Encontra e abre o primeiro .modal dentro do conteúdo carregado
      const modalEl = container.querySelector(".modal")
      if (modalEl) {
        const ModalClass = window.bootstrap?.Modal || bootstrap?.Modal
        if (ModalClass) {
          const modal = new ModalClass(modalEl)
          modal.show()

          // Limpa o container quando o modal fechar
          modalEl.addEventListener("hidden.bs.modal", () => {
            container.innerHTML = ""
          }, { once: true })
        }
      }
    } catch (e) {
      console.error("[remote-modal] Erro ao carregar conteúdo:", e)
    }
  }
}
